import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const ContentHeader = styled.div(() =>
  mq({
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    margin: `${defaultTheme.spacing.xxl} 0 32px`,
    '& > h1': {
      marginTop: defaultTheme.spacing.l,
    },
  }),
);

export const BodyWrapper = styled.div(() =>
  mq({
    lineHeight: 1.8,
  }),
);

export const PublishedAt = styled.time(() =>
  mq({
    color: defaultTheme.text.time,
    fontSize: defaultTheme.font.size.s,
  }),
);

export const Title = styled.h1(() =>
  mq({
    fontSize: defaultTheme.font.size.l,
    fontWeight: 'bold',
    lineHeight: '25.2px',
  }),
);
